import { Select } from "../../components/Select.js"
import styles from "./SortBar.module.css"
import type { SortKey, SortOrder } from "./useBenefits.js"

const SORT_OPTIONS: { sort: SortKey; order: SortOrder; label: string }[] = [
  { sort: "code", order: "asc", label: "証券コード順" },
  { sort: "benefitValue", order: "asc", label: "優待金額 (低い順)" },
  { sort: "benefitValue", order: "desc", label: "優待金額 (高い順)" },
  { sort: "combinedYield", order: "desc", label: "総合利回り (高い順)" },
  { sort: "combinedYield", order: "asc", label: "総合利回り (低い順)" },
  { sort: "dividendYield", order: "desc", label: "配当利回り (高い順)" },
  { sort: "dividendYield", order: "asc", label: "配当利回り (低い順)" },
  { sort: "benefitYield", order: "desc", label: "優待利回り (高い順)" },
  { sort: "benefitYield", order: "asc", label: "優待利回り (低い順)" },
  { sort: "marketCap", order: "desc", label: "時価総額 (大きい順)" },
  { sort: "marketCap", order: "asc", label: "時価総額 (小さい順)" },
  { sort: "acquisitionAmount", order: "asc", label: "最低取得額 (低い順)" },
  { sort: "recordDate", order: "asc", label: "権利確定日が近い順" },
  { sort: "lastChanged", order: "desc", label: "更新日が新しい順" },
]

interface Props {
  total: number
  totalAll: number
  sort: SortKey
  order: SortOrder
  onChange: (sort: SortKey, order: SortOrder) => void
}

export function SortBar({ total, totalAll, sort, order, onChange }: Props) {
  const selectedValue = `${sort}-${order}`

  return (
    <div className={styles.bar}>
      <span className={styles.count}>
        {total.toLocaleString()}件
        {total !== totalAll && (
          <span className={styles.totalAll}> / 全{totalAll.toLocaleString()}件</span>
        )}
      </span>
      <Select
        ariaLabel="並び替え"
        value={selectedValue}
        options={SORT_OPTIONS.map(({ sort: s, order: o, label }) => ({
          value: `${s}-${o}`,
          label,
        }))}
        onChange={(v) => {
          const [s, o] = v.split("-") as [SortKey, SortOrder]
          onChange(s, o)
        }}
      />
    </div>
  )
}
